import { createSlice } from '@reduxjs/toolkit'

// import { FALSE } from 'sass'
const slice = createSlice({
  name: 'Order Management',
  initialState: {
    orderList: [],
    orderListLoading: false,
    orderListPaginationData: {},

    getOrderListDetails: [],
    getOrderListDetailsLoading: false,
  },
  reducers: {
    getOrderListApiData: (state, { payload }) => {
      state.orderListLoading = true
    },
    getOrderListApiDataSuccess: (state, { payload }) => {
      state.orderListLoading = false
      state.orderList = payload?.payload?.data
      state.orderListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getOrderListApiDataFailed: (state, { payload }) => {
      state.orderListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // details Store type
    getOrderListDetailsListApiData: (state, { payload }) => {
      state.getOrderListDetailsLoading = true
    },
    getOrderListDetailsListApiSuccess: (state, { payload }) => {
      state.getOrderListDetails = payload?.payload?.data
      state.getOrderListDetailsLoading = false
    },
    getOrderListDetailsListApiFailed: (state, { payload }) => {
      state.getOrderListDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
  },
})

export const {
  // Get Order Details
  getOrderListDetailsListApiData,
  getOrderListDetailsListApiSuccess,
  getOrderListDetailsListApiFailed,

  // Store Type
  getOrderListApiData,
  getOrderListApiDataSuccess,
  getOrderListApiDataFailed,
} = slice.actions

export default slice.reducer
